import React from 'react'
import cx from 'classnames'
import './style.css'

const YourAppsSection = ({ className }) => (
  <div className={cx('your-apps-section', className)}>
    <span>
      Your Apps
    </span>
  </div>
)

export default YourAppsSection
